import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();

  const handleNavClick = (path: string) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-global-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                {t("site.name")}
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              {t("site.slogan")}
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">
              {t("nav.categories")}
            </h4>
            <div className="flex flex-col gap-2">
              {["跨境商务", "国际投资", "文化交流", "出行移民"].map((cat) => (
                <Link
                  key={cat}
                  to="/category/cross-border-business"
                  onClick={() => handleNavClick("/category/cross-border-business")}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap no-underline"
                >
                  {cat}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                onClick={() => handleNavClick("/")}
                className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap no-underline"
              >
                {t("nav.home")}
              </Link>
              <Link
                to="/about"
                onClick={() => handleNavClick("/about")}
                className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap no-underline"
              >
                {t("nav.about")}
              </Link>
              <Link
                to="/category/cross-border-business"
                onClick={() => handleNavClick("/category/cross-border-business")}
                className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap no-underline"
              >
                {t("nav.articles")}
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">
              {t("about.contact.title")}
            </h4>
            <div className="flex flex-col gap-2">
              <div className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line mt-0.5 text-background-500"></i>
                <span>香港中环皇后大道中99号</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-background-500"></i>
                <span>+852 2888 8888</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-background-500"></i>
                <span>contact@1996zhcheng.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">{t("footer.copyright")}</p>
          <div className="flex items-center gap-4 text-sm text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap no-underline">{t("footer.privacy")}</a>
            <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap no-underline">{t("footer.terms")}</a>
            <span className="whitespace-nowrap">{t("footer.icp")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}